export default __webpack_public_path__ + "static/media/Rectangle_88.bb395b12.png";